import Yandex from './Yandex'

export default Yandex
// eslint-disable-next-line import/export
export * from './Yandex'
